export class SearchDocument {
    constructor(searchRepository) {
      this.searchRepository = searchRepository;
    }
  
    async execute(SearchRequest) {
      return await this.searchRepository.SearchDocument(SearchRequest);
    }
  }